<template>
    <div id="editBuliting">
        <div style="height:56px;background:#ccc">
            <div class="mainHead">
                <div class="route">
                <span class="crumbs"></span><span class="link">建筑管理</span><span class="arrow">></span><span v-if="saveBtn">{{title}}建筑信息</span><span v-else>查看建筑信息</span>
                </div>
                <div>
                    <el-button v-show="!saveBtn" v-if="isAuth('basicData:delBuildingByPrimarykey')" type="primary" @click="deleteBuliting">删除</el-button>
                <el-button v-show="!saveBtn" type="primary" v-if="isAuth('basicData:editBuildingInfo')" @click="bulitEdit">编辑</el-button>
                <!-- <el-button type="primary" @click="saveBtn ? goback() : go()">返回</el-button> -->
                </div>
            </div>
        </div>
        <div class="content">
            <el-form ref="form" :rules="rules" :model="form" label-width="168px">
                <div class="from_left">
                    <div class="grid-content bg-purple">
                        <el-form-item :required="saveBtn" :show-message="!saveBtn" label="建筑名称：" prop="buildingName">
                            <el-input :disabled="!saveBtn" maxlength="20" v-model="form.buildingName" placeholder="长度不超过20个字符"></el-input>
                        </el-form-item>
                        <el-form-item class="area" label="建筑面积：" prop="area">
                            <!-- <span v-if="!saveBtn && form.area == null" style="width: 310px; display: inline-block;">--</span> -->
                            <el-input :disabled="!saveBtn" onkeyup="value=value.replace(/\D/g,'')" v-model="form.area" :placeholder="!saveBtn && (form.area == null || form.area == '') ? '--' : '请输入数字'" :class="{disabled_color:!saveBtn}"></el-input>
                            <div class="left_m">平方米</div>
                        </el-form-item>
                        <el-form-item :required="saveBtn" :show-message="!saveBtn" label="建筑地址："  prop="address">
                            <el-tooltip class="item"  :content="form.address.join('|')" :disabled="!saveBtn ? overflowText < 20 : true" placement="bottom-start">
                                <el-cascader
                                @mouseover.native="changeText($event)"
                                :options="options"
                                v-model="form.address"
                                :props ='defaultProps'
                                :disabled="!saveBtn"
                                separator='|'
                                popper-class="linkage"
                               >
                            </el-cascader>
                            </el-tooltip>
                            <div class="tipHint"></div>
                        </el-form-item>
                    </div>
                </div>
                <div class="from_left">
                    <div class="grid-content bg-purple">
                        <el-form-item :required="saveBtn" :show-message="!saveBtn" class="left" label="建筑层数：" prop="onFloor">
                            <el-input onkeyup="value=value.replace(/\D/g,'')" :disabled="!saveBtn" maxlength="3" v-model="form.onFloor" placeholder="地上"></el-input>
                        </el-form-item>
                        <el-form-item :required="saveBtn" class="left right" prop="underFloor" :show-message="!saveBtn">
                            <el-input onkeyup="value=value.replace(/\D/g,'')" :disabled="!saveBtn" maxlength="3" v-model="form.underFloor" placeholder="地下"></el-input>层
                        </el-form-item>
                        <el-form-item class="area" label="占地面积：" prop="coverArea">
                            <!-- <span v-if="!saveBtn && form.coverArea == null" style="width: 310px; display: inline-block;">--</span> -->
                            <el-input :disabled="!saveBtn" onkeyup="value=value.replace(/\D/g,'')" v-model="form.coverArea" :placeholder="!saveBtn && (form.coverArea == null || form.coverArea == '') ? '--' : '请输入数字'" :class="{disabled_color:!saveBtn}"></el-input>
                            <div class="left_m">平方米</div>
                        </el-form-item>
                        <el-form-item :required="saveBtn" :show-message="!saveBtn" label="详细地址：" prop="detailAddress">
                            <el-tooltip class="item"  :content="form.detailAddress" :disabled="!saveBtn ? len : true" placement="bottom-start">
                                <el-input @mouseover.native="changeText1()" id="detailAddress" ref="detailAddressLength" :disabled="!saveBtn" v-model="form.detailAddress" placeholder="长度不超过30个字符" :maxlength="30"></el-input>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item v-show="saveBtn" style="margin-top:20px">
                    <el-button type="primary" @click="!editsavebtn ? save() : editsave()">保存</el-button>
                </el-form-item>
            </el-form>
            <!-- 提示框(自动消失) -->
            <el-dialog title="提示" class="tips" :visible.sync="dialogTipsVisible" :modal="false" @open="openDialog">
                <span>{{tips}}</span>
                <span slot="footer" class="dialog-footer">
                    <el-button style="min-width:80px" type="primary" @click="dialogTipsVisible = false">我知道了</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import jsonData from '../../../static/addressData/address.json'
import {ajaxFuncJson} from '@/api/ajax';

export default {
    name: 'editBuliting',
    data() {
        var checkArea = (rule,value,callback) => {
            let reg = /^[1-9]\d*$/
            if (value == '' || value == null) {
                callback();
            } else {
                if(!reg.test(value)) {
                    return callback(new Error(' '));
                } else {
                    callback();
                }
            }
        };
        var checkFloor = (rule,value,callback) => {
            let reg = /^[0-9]\d*$/
            if (value + '' != '') {
                if(!reg.test(value)) {
                    return callback(new Error(' '));
                } else {
                    callback();
                }
            } else {
                return callback(new Error(' '));
            }
        };
        return {
            rules: {
                buildingName: [
                    { max: 20, message: ' ', trigger: 'blur' }
                ],
                area: [
                    // {validator: checkArea, trigger: 'blur',type:'number'}
                ],
                coverArea: [
                    // {validator: checkArea, trigger: 'blur',type:'number'}
                ],
                address: [
                    { message: ' ', trigger: 'blur, change',type:'array'}
                ],
                onFloor: [
                    // { message: ' ', trigger: 'blur'},
                    { validator: checkFloor}
                ],
                underFloor: [
                    // { message: ' ', trigger: 'blur'},
                    { validator: checkFloor}
                ],
                detailAddress: [
                    { message: ' ', trigger: 'blur'}
                ]
            },
            options: [],
            defaultProps: {
                children: 'children',
                label: 'name',
                value: 'name',
            },
            dialogTipsVisible: false,
            tips:'信息填写不完善，请完善信息！', //提示语
            editsavebtn: false,
            floorid: '',
            overflowText: '',
            len: true,
            title:'新增'
        }
    },
    computed: {
        saveBtn: {
            get() {
                return this.$store.state.saveBtn
            },
            set(val) {
                this.$store.state.saveBtn = val
            }
        },
        form() {
            return this.$store.state.editBulitData
        },
    },
    created() {
        this.options = jsonData;
        sessionStorage.setItem('sav','');
    },
    watch: {
        saveBtn(val) {
            this.$nextTick(() => {
                if (val) {
                    this.$refs.form.clearValidate()  // 清除表单验证防止 xxx is required
                }
            })
        }
    },
    mounted() {
        sessionStorage.setItem('navAddShow',true);
    },
    methods: {
        changeText1() {
            let _this = this
            let len = 0;
            let val = _this.$refs.detailAddressLength.value;
            for (var i = 0; i < val.length; i++) {
                var a = val.charAt(i);
                if (a.match(/[^\x00-\xff]/ig) != null) {
                    len += 2;
                } else {
                    len += 1;
                }
            }
            if (len/2 * 13 > 282) {
                this.len = false;
            } else {
                this.len = true;
            }
        },
        openDialog() {
            setTimeout(() => {
                this.dialogTipsVisible = false
                this.tips = '信息填写不完善，请完善信息！';
            },6000)
        },
        //文字显示...
        changeText(e){
            this.overflowText = $(e.toElement)[0].innerText.length;
        },
        getLeftRightData(id) {
            let _this = this;
            if(_this.isAuth('common:interface')) {
                let params = {
                    buildingId: id,
                }
                ajaxFuncJson('/basicData/getBuildingFloor',params).then(res=>{
                // 查询楼层列表
                    if(res.data.status == 200) {
                        // _this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'));
                        if (res.data.data.length != '0') {        
                            sessionStorage.setItem('rightList',true);  // 右侧楼层显示
                            _this.$store.state.rightList = true
                            _this.floorListData = res.data.data
                            _this.floorListData.map(e => {
                                if (e.floorIndexs == '1') {  // 默认L1层
                                    e.active = true
                                } else {
                                    e.active = false
                                }
                            })
                            sessionStorage.setItem('floorData',JSON.stringify(_this.floorListData));
                            _this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'))
                            res.data.data.map( e => {
                                if (e.floorIndexs == '1') {
                                    _this.floorid = e.id;
                                    sessionStorage.setItem('floorIndex',e.floorIndex)
                                }
                            })
                            if (_this.$store.state.floorList.length > 5) {
                                if (_this.$store.state.floorList.findIndex( e => e.floorIndex == 1) > 4) {
                                _this.$store.state.floorListIndexL1 = - (_this.$store.state.floorList.findIndex( e => e.floorIndex == 1) - 4) * 40;
                                } else {
                                _this.$store.state.floorListIndexL1 = 0
                                }
                            } else if (_this.$store.state.floorList.length == 0){

                            } else {
                                _this.$store.state.floorListIndexL1 = 0
                            } 
                            let params = {
                                buildingId: id,
                                customerId: sessionStorage.getItem('customerId'),
                                floorId: _this.floorid,
                                remark: '1'
                            }
                            ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
                                sessionStorage.setItem('floor','1'); //点击客户还是楼层0表示客户
                                sessionStorage.setItem('pointData',JSON.stringify(res.data.data));
                                _this.$store.dispatch('getRightPoint',res.data.data);
                            });
                        } else {
                            sessionStorage.setItem('floorData',JSON.stringify(res.data.data));
                            _this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'))
                            sessionStorage.setItem('rightList',false);  // 右侧楼层显示
                            _this.$store.state.rightList = false;
                            sessionStorage.setItem('floorIndex','')
                            let params = {
                                buildingId: id,
                                customerId: sessionStorage.getItem('customerId'),
                                floorId: '',
                                remark: '1'
                            }
                            ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
                                sessionStorage.setItem('floor','1'); //点击客户还是楼层0表示客户
                                sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                                _this.$store.dispatch('getRightPoint',res.data.data);
                                // this.$router.push({path:'/content/constructionManagement'})
                            });
                        }
                    }
                });
            }
        },
        deleteBulit() {
            let _this = this
            let params = {
                buildingId: sessionStorage.getItem('buildingId'),
                customerId: sessionStorage.getItem('customerId'),
                remark: '1',
            }
            ajaxFuncJson('/basicData/delBuildingByPrimarykey',params).then(res=>{
                if (res.data.status == 200) {
                    _this.$router.push({path:'/content/delSuccessfully1',query:{flag:false}})
                    if(this.isAuth('common:interface')) {
                        // 刷新左侧数据
                        let params1 = {
                            buildingName: '',
                            target: '1'
                        }
                const TIME_COUNT = 5;
                if(!_this.timer){
                    _this.count = TIME_COUNT;
                    _this.timer = setInterval(()=>{
                        if(_this.count > 0 && _this.count <= TIME_COUNT){
                            _this.count--;
                        }else{
                            clearInterval(_this.timer);
                            _this.timer = null;
                            // 延时器开始
                        ajaxFuncJson('/basicData/getBuilding',params1).then(res=>{
                            if (res.data.status == 200) {
                                if (_this.$store.state.leftMonitorInfo.length == 1) {  // 一个客户时
                                    _this.$store.state.leftMonitorInfo.map( i => {
                                        // if(i.children.length == 1) {                   // 一个建筑时
                                            // 获取客户数据
                                            sessionStorage.setItem('menuS',i.id);
                                            _this.$store.state.menuS = i.id;
                                            sessionStorage.setItem('Name',i.label);
                                            let params1 = {
                                                customerId: i.id,
                                                target: '1'
                                            }
                                            ajaxFuncJson('/basicData/getMonitorByCustomerId',params1).then(res=>{
                                                if (res.data.status == 200) {
                                                    sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                                                    this.$store.dispatch('getRightPoint',res.data.data)

                                                }
                                            })
                                        // } else if(i.children.length > 1) {             // 多个建筑时
                                        //     i.children.map( (e,index) => {
                                        //         if (e.id == sessionStorage.getItem('buildingId')) {
                                        //             if (index == 0) {
                                        //                 sessionStorage.setItem('menuS',i.children[index + 1].id);
                                        //                 _this.$store.state.menuS = i.children[index + 1].id
                                        //                 sessionStorage.setItem('Name',i.children[index + 1].label);
                                        //                 _this.getLeftRightData(i.children[index + 1].id);
                                        //             } else {
                                        //                 _this.getLeftRightData(i.children[index - 1].id);
                                        //                 sessionStorage.setItem('Name',i.children[index - 1].label);
                                        //                 sessionStorage.setItem('menuS',i.children[index - 1].id)
                                        //                 _this.$store.state.menuS = i.children[index - 1].id
                                        //             }
                                        //         }
                                        //     })
                                        // }
                                    })
                                } else if (_this.$store.state.leftMonitorInfo.length > 1) {  // 多个客户时
                                    
                                    // _this.$store.state.leftMonitorInfo.map( i => {
                                    //     i.children.map( (e,index) => {
                                    //         if (e.id == sessionStorage.getItem('buildingId')) {
                                    //             if (index == 0) {
                                    //                 sessionStorage.setItem('menuS',i.children[index + 1].id);
                                    //                 sessionStorage.setItem('Name',i.children[index + 1].label);
                                    //                 _this.getLeftRightData(i.children[index + 1].id);
                                    //             } else {
                                    //                 _this.getLeftRightData(i.children[index - 1].id);
                                    //                 sessionStorage.setItem('Name',i.children[index - 1].label);
                                    //                 sessionStorage.setItem('menuS',i.children[index - 1].id)
                                    //             }
                                    //         }
                                    //     })
                                    // })
                                    // _this.$store.state.leftMonitorInfo[0].children.map( (e,index) => {
                                    //     if (e.id == sessionStorage.getItem('buildingId')) {
                                    //         if (index == 0) {  // 如果是客户的第一栋建筑删除就就加载下面的一栋建筑楼层和点位数据
                                    //             if (_this.$store.state.leftMonitorInfo.length > 1) {
                                    //                 _this.getLeftRightData(_this.$store.state.leftMonitorInfo[0].children[index + 1].id);
                                    //             }
                                    //         } else {     // 加载上一栋的数据
                                    //             _this.getLeftRightData(_this.$store.state.leftMonitorInfo[0].children[index - 1].id);
                                    //             sessionStorage.setItem('Name',_this.$store.state.leftMonitorInfo[0].children[index - 1].label)
                                    //         }
                                    //     }
                                    // })
                                }
                                sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
                                _this.$store.dispatch('getLeftDataList',res.data.data)
                            } else {
                                _this.$message.error(res.data.msg)
                            }
                        })

                            // 延时器结束
                            // this.$router.push({path:'/content/editBuliting'}); //监测点首页
                            // this.getBuilding();//左侧
                        }
                    },1000)
                }


                    }
                    _this.$router.push({path:'/content/delSuccessfully1',query:{flag:false}})
                } else {
                    _this.$message.error(res.data.msg)
                }
            })
        },
        deleteBuliting() {
            let params = {
                buildingId: sessionStorage.getItem('buildingId'),
                customerId: sessionStorage.getItem('customerId'),
                remark: '2',
            }
            ajaxFuncJson('/basicData/delBuildingByPrimarykey',params).then(res=>{
                if (res.data.status == 200) {
                    this.deleteBulit()
                } else if (res.data.status == 305) {
                    this.$confirm('继续操作将删除当前建筑！', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        }).then(() => {
                            this.deleteBulit()
                        }).catch(() => {
                                
                    });
                } else if (res.data.status == 306) {
                    this.$alert('当前建筑下存在监测点，请先删除监测点！', '提示', {
                        confirmButtonText: '确定',
                    });
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        bulitEdit() {
            this.saveBtn = true;
            this.$store.state.saveBtn = true;
            this.editsavebtn = true;
            this.$refs.form.clearValidate();
            this.title = "编辑"
        },
        goback() {
            // this.$router.push({path:'/content/constructionManagement',query:{floorFlag: '1'}}); //监测点首页
        },
        go() {
            // sessionStorage.setItem('differentiate',false)
            // this.$router.push({path:'/content/constructionManagement',query:{floorFlag: true}}); //监测点首页
        },
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                  if(Math.abs(this.form.underFloor)+Math.abs(this.form.onFloor)>=1){
                    let params = {
                      buildingName: this.form.buildingName,
                      area: this.form.area == '' ? '0' : this.form.area,
                      address: this.form.address.join('|'),
                      onFloor: this.form.onFloor,
                      underFloor: this.form.underFloor,
                      coverArea: this.form.coverArea == '' ? '0' : this.form.coverArea,
                      detailAddress: this.form.detailAddress,
                      customerId: sessionStorage.getItem('customerId'),
                      enterprise: sessionStorage.getItem('customerName')
                    }
                    ajaxFuncJson('/basicData/insertBuildInfo',params).then(res=>{
                      if (res.data.status == 200) {
                        this.getBuilding()
                        sessionStorage.setItem('editbuiltID',res.data.data);
                        sessionStorage.setItem('menuS',res.data.data);
                        sessionStorage.setItem('buildingId',res.data.data)
                        sessionStorage.setItem('sav','sav')
                      } else {
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                      }
                    })
                  }else {
                    this.$alert('请至少输入一层建筑！', '提示', {
                      confirmButtonText: '我知道了',
                      callback: action => {

                      }
                    });
                  }
                } else {
                    this.dialogTipsVisible = true;
                    return false;
                }
            });
        },
        editsave() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                  if(Math.abs(this.form.underFloor)+Math.abs(this.form.onFloor)>=1){
                    let params = {
                      buildingName: this.form.buildingName,
                      area: this.form.area == '' ? '0' : this.form.area,
                      address: this.form.address.join('|'),
                      onFloor: this.form.onFloor,
                      underFloor: this.form.underFloor,
                      coverArea: this.form.coverArea == '' ? '0' : this.form.coverArea,
                      detailAddress: this.form.detailAddress,
                      customerId: sessionStorage.getItem('customerId'),
                      enterprise: sessionStorage.getItem('customerName'),
                      id: sessionStorage.getItem('editbuiltID'),
                    }
                     if(this.form.onFloor != JSON.parse(sessionStorage.getItem('editBulitData')).onFloor || this.form.underFloor != JSON.parse(sessionStorage.getItem('editBulitData')).underFloor){
                        params.flag = true;
                        this.$confirm('修改建筑楼层数将会清空楼层标记信息，是否确定继续操作？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            }).then(() => {
                                ajaxFuncJson('/basicData/editBuildingInfo',params).then(res=>{
                                if (res.data.status == 200) {
                                    this.getBuilding()
                                    sessionStorage.setItem('sav','sav')
                                } else {
                                    this.$message(res.data.msg);
                                }
                                })
                            }).catch(() => {});
                     }else{
                        params.flag = false
                        ajaxFuncJson('/basicData/editBuildingInfo',params).then(res=>{
                        if (res.data.status == 200) {
                            this.getBuilding()
                            sessionStorage.setItem('sav','sav')
                        } else {
                            this.$message(res.data.msg);
                        }
                        })
                     }    
                  }else {
                    this.$alert('请至少输入一层建筑！', '提示', {
                      confirmButtonText: '我知道了',
                      callback: action => {

                      }
                    });
                  }
                } else {
                    this.dialogTipsVisible = true;
                    return false;
                }
            });
        },
        getBuilding() {
            if(this.isAuth('common:interface')) {
                let params = {
                    buildingName: ''
                }
                ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
                    // 查询建筑列表
                    sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
                    this.$store.dispatch('getLeftDataList',res.data.data)
                    var _this = this
                    setTimeout(function (){
                            _this.$router.push({path:'/content/saveSuccessfully1',query:{flag:true}})
                    }, 100);
                });
            }
        },
    },
    beforeRouteLeave (to, from , next) {
        if (sessionStorage.getItem('sav') == '') {
            if (this.form.address.join('') == JSON.parse(sessionStorage.getItem('editBulitData')).address.join('') &&  this.form.area == JSON.parse(sessionStorage.getItem('editBulitData')).area && this.form.buildingName == JSON.parse(sessionStorage.getItem('editBulitData')).buildingName && this.form.coverArea == JSON.parse(sessionStorage.getItem('editBulitData')).coverArea && this.form.detailAddress == JSON.parse(sessionStorage.getItem('editBulitData')).detailAddress && this.form.onFloor == JSON.parse(sessionStorage.getItem('editBulitData')).onFloor && this.form.underFloor == JSON.parse(sessionStorage.getItem('editBulitData')).underFloor) {
                next()
            } else {
                this.$confirm('当前已输入信息，离开将无法保存当前页面。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    }).then(() => {
                        next()
                        this.getLeftRightData(sessionStorage.getItem('editbuiltID'))
                        sessionStorage.setItem('Name', JSON.parse(sessionStorage.getItem('editBulitData')).buildingName)
                    }).catch(() => {
                        next(false)
                        sessionStorage.setItem('menuS',sessionStorage.getItem('editbuiltID'))
                        this.$store.state.menuS = sessionStorage.getItem('editbuiltID')
                });
            }
        } else {
            next()
        }
    },
}
</script>

<style lang="scss" scope>
#editBuliting {
    background: #fff;
    height: 100%;
    .content {
        margin-top: 40px;
        .from_left {
            display: inline-block;
            .area .el-input {
                width: 300px;
                margin-right: 10px;
            }
            .area .el-input,.left_m {
                display: inline-block;
            }
            .el-cascader__label {
                cursor: default;
            }
        }
        .left {
            display: inline-block;
            width: auto !important;
            input {
                width: 140px !important;
                margin-right: 16px;
            }
        }
        .right .el-form-item__content{
            margin-left: 0px !important;
            .el-input {
                width: 91%;
            }
        }
    }
}
.tipHint{
  background: red;
  background: #fff;
  height: 20px;
  position: absolute;
  width: 100%;
  top: 35px;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// src/page/editBuliting/editBuliting.vue